const pathRewrite = '/api';
export const dyjAPI = {
  getLatestSmpls: pathRewrite + '/get_latest_smpls_from_dyj',
  getAllMtrls: pathRewrite + '/get_mtrls_from_dyj',
  getCompsList: pathRewrite + '/get_mtrl_comps_from_dyj',
  getColorList: pathRewrite + '/get_mtrl_colors_from_dyj',
  getAllSmpls: pathRewrite + '/get_smpls_from_dyj',
  getNpsmsFromDyj: pathRewrite + '/get_npsms_from_dyj',
  getSmplList: pathRewrite + '/smplList',
  getSalesContract: pathRewrite + '/country/getSalesContract',
  getProcurement: pathRewrite + '/country/getProcurement',
  getShipping: pathRewrite + '/country/getShipping',
  getWeeklyPoReport: pathRewrite + '/earp/getWeeklyPoReport',
  exportExcelSalesContract: pathRewrite + '/country/exportExcelSalesContract',
  exportExcelShipping: pathRewrite + '/country/exportExcelShipping',
  exportExcelProcurement: pathRewrite + '/country/exportExcelProcurement',
  exportWeeklyPoReport: pathRewrite + '/earp/exportWeeklyPoReport',
  pushFactorySnapshot: pathRewrite + '/syy/pushFactorySnapshot'
};
